import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../_globals/globals';

export type AssistantUserUpdateKind =
  | 'documentation'
  | 'bug_fixed'
  | 'feature_available';

export interface AssistantUserUpdate {
  id: number;
  reviewId: number;
  product: string;
  kind: AssistantUserUpdateKind;
  title: string;
  content: string;
  version?: string;
  knowledgeSourceId?: string;
  publishedAt: string;
  readAt?: string;
}

export interface AssistantUserUpdateInbox {
  unreadCount: number;
  items: AssistantUserUpdate[];
}

@Injectable({ providedIn: 'root' })
export class AssistantUpdatesService {
  inbox: AssistantUserUpdateInbox = {
    unreadCount: 0,
    items: []
  };
  loading = false;
  loaded = false;
  error = '';

  constructor(
    private http: HttpClient,
    private globals: Globals
  ) {}

  load(forceIn?: boolean): void {
    if (this.loading || (this.loaded && !forceIn)) {
      return;
    }
    this.loading = true;
    this.error = '';
    this.http.get<AssistantUserUpdateInbox>(
      this.globals.apiUrl + '/help/updates'
    ).subscribe(
      response => {
        this.loading = false;
        this.loaded = true;
        this.inbox = {
          unreadCount: response && Number(response.unreadCount) > 0
            ? Number(response.unreadCount)
            : 0,
          items: response && Array.isArray(response.items)
            ? response.items
            : []
        };
      },
      () => {
        this.loading = false;
        this.loaded = true;
        this.error = 'No ha sido posible consultar tus novedades.';
      }
    );
  }

  markRead(
    updateIn: AssistantUserUpdate,
    successIn?: () => void,
    errorIn?: () => void
  ): void {
    if (!updateIn || updateIn.readAt) {
      if (successIn) {
        successIn();
      }
      return;
    }
    this.http.post<any>(
      this.globals.apiUrl + '/help/updates/' + updateIn.id + '/read',
      {}
    ).subscribe(
      () => {
        updateIn.readAt = new Date().toISOString();
        this.inbox.unreadCount = Math.max(0, this.inbox.unreadCount - 1);
        if (successIn) {
          successIn();
        }
      },
      () => {
        if (errorIn) {
          errorIn();
        }
      }
    );
  }
}
